import { useState } from "react";

import { authEndpoints } from "../../api/endpoints";

export default function usePasswordChange(apiClient, showMsg = null) {
  const [newPassword1, setNewPassword1] = useState(null);
  const [newPassword2, setNewPassword2] = useState(null);

  const onSubmit = async () => {
    if (newPassword1 !== newPassword2) {
      setNewPassword1(null);
      setNewPassword2(null);
      showMsg?.("Die Passwörter stimmen nicht überein!", "error");
    } else {
      try {
        await apiClient.post(authEndpoints.passwordchange, {
          new_password: newPassword1,
        });
        showMsg?.("Passwort geändert!");
      } catch (error) {
        showMsg?.(
          error?.response?.data
            ? error.response.data.join(" ")
            : "Passwort konnte nicht geändert werden!",
          "error",
        );
      } finally {
        setNewPassword1(null);
        setNewPassword2(null);
      }
    }
  };

  return {
    onSubmit,
    password1: { value: newPassword1, setValue: setNewPassword1 },
    password2: { value: newPassword2, setValue: setNewPassword2 },
  };
}
